<app-block-wrapper [_editable]="_editable" [style]="style">
  <video
    #videoEl
    autoplay
    loop
    muted
    playsinline
    disablepictureinpicture="true"
    [width]="dimensions.width"
    [height]="dimensions.height"
    [poster]="poster?.filename | storyblokCdn"
    *ngIf="dimensions"
  >
    <source [src]="video?.filename | storyblokCdn" />
  </video>
</app-block-wrapper>
